module.exports = __webpack_public_path__ + "img/bmw.89778807.png";